import { Icon } from 'prensa'
import React from 'react'

const LeftArrowIcon = (props) => {
  return (
    <Icon color='black' width='18px' height='18px' viewBox='0 0 18 18' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d="M15 8.25H5.87l4.19-4.19L9 3 3 9l6 6 1.06-1.06-4.19-4.19H15v-1.5z"/>
    </Icon>
  )
}

export { LeftArrowIcon }